import React from 'react';
import { Option } from 'src/components/SelectBox';
import { AutoCompleteInput } from 'src/components/AutoCompleteInput';
import useAuthedRequest from 'src/hooks/useAuthedRequest';
import { useWizard } from 'src/pages/Automations/components/wizard/WizardContext';
import { ProviderSelect } from './ProviderSelect';
import { Label } from 'src/components/Label';

export interface EmailProviderSelectionProps {
  onChange: (providerOption: { value: string; label: string }) => void;
  isAuthenticated?: boolean;
}

export const EmailProviderSelect: React.FC<EmailProviderSelectionProps> = ({
  onChange,
  isAuthenticated = false,
}) => {
  const { emailProviders, campaignAutomation, setCampaignAutomation } =
    useWizard();
  const { get, remove } = useAuthedRequest();

  const handleChange = (option: Option) => {
    onChange({
      value: option.value,
      label: option.label || option.value,
    });
  };

  const fetchLastEmails = async (search: string) => {
    try {
      const data = await get(`/emails/recent?email=${search}`);
      return data.map((i: { id: string; email: string }) => ({
        id: i.id,
        label: i.email,
        value: i.email,
      }));
    } catch (error) {
      console.error('Failed to fetch last emails:', error);
      return [];
    }
  };

  const handleFromEmailChange = (value: string) => {
    setCampaignAutomation({
      ...campaignAutomation,
      fromEmail: value,
    });
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <Label
          className="text-sm font-medium text-neutral-700 mb-2 block"
          required
        >
          Select email provider
        </Label>

        <ProviderSelect
          providers={emailProviders}
          selectedProvider={campaignAutomation.emailProviderOption}
          onChange={handleChange}
          isAuthenticated={isAuthenticated}
          label=""
          htmlFor="email-provider"
          className="w-full bg-neutral-0 h-12"
        />
      </div>

      {isAuthenticated && (
        <div>
          <Label className="text-sm font-medium text-neutral-700 mb-2 block">
            From email
          </Label>

          <AutoCompleteInput
            label=""
            id="email-from"
            placeholder="Enter sender email"
            value={campaignAutomation.fromEmail || ''}
            onChange={handleFromEmailChange}
            onRemove={(value) => remove(`/emails/recent/${value}`)}
            required
            fetchOptions={fetchLastEmails}
            className="w-full h-12"
          />
        </div>
      )}
    </div>
  );
};
